// extracted by mini-css-extract-plugin
module.exports = {"thinking-dots":"ThinkingDots_thinking-dots__Wxrvi","dot":"ThinkingDots_dot__ZuI6b"};